import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1fd31550 = () => interopDefault(import('../../../pages/contacts/index.vue' /* webpackChunkName: "pages/contacts/index" */))
const _76dc8539 = () => interopDefault(import('../../../pages/data-pools/index.vue' /* webpackChunkName: "pages/data-pools/index" */))
const _7d05a12e = () => interopDefault(import('../../../pages/documents/index.vue' /* webpackChunkName: "pages/documents/index" */))
const _1be2b3b7 = () => interopDefault(import('../../../pages/imprint.vue' /* webpackChunkName: "pages/imprint" */))
const _262427fe = () => interopDefault(import('../../../pages/logged-in.vue' /* webpackChunkName: "pages/logged-in" */))
const _500d2497 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _68f07894 = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _12d8c0b0 = () => interopDefault(import('../../../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _3a593486 = () => interopDefault(import('../../../pages/tos.vue' /* webpackChunkName: "pages/tos" */))
const _9ab3c4aa = () => interopDefault(import('../../../pages/backoffice/usermanagement/index.vue' /* webpackChunkName: "pages/backoffice/usermanagement/index" */))
const _6111e6e4 = () => interopDefault(import('../../../pages/data-pools/manage.vue' /* webpackChunkName: "pages/data-pools/manage" */))
const _38b3c2f0 = () => interopDefault(import('../../../pages/password/forgot/index.vue' /* webpackChunkName: "pages/password/forgot/index" */))
const _69ded25c = () => interopDefault(import('../../../pages/registration/submit.vue' /* webpackChunkName: "pages/registration/submit" */))
const _2a6c1a00 = () => interopDefault(import('../../../pages/settings/ci.vue' /* webpackChunkName: "pages/settings/ci" */))
const _18bf88e2 = () => interopDefault(import('../../../pages/settings/legal.vue' /* webpackChunkName: "pages/settings/legal" */))
const _30be68b2 = () => interopDefault(import('../../../pages/user/profile.vue' /* webpackChunkName: "pages/user/profile" */))
const _cce4bc98 = () => interopDefault(import('../../../pages/backoffice/usermanagement/companies.vue' /* webpackChunkName: "pages/backoffice/usermanagement/companies" */))
const _0c51e29a = () => interopDefault(import('../../../pages/backoffice/usermanagement/registrations.vue' /* webpackChunkName: "pages/backoffice/usermanagement/registrations" */))
const _9ab097ce = () => interopDefault(import('../../../pages/backoffice/usermanagement/roles/index.vue' /* webpackChunkName: "pages/backoffice/usermanagement/roles/index" */))
const _262151a4 = () => interopDefault(import('../../../pages/backoffice/usermanagement/users/index.vue' /* webpackChunkName: "pages/backoffice/usermanagement/users/index" */))
const _35e0a5b9 = () => interopDefault(import('../../../pages/password/forgot/success.vue' /* webpackChunkName: "pages/password/forgot/success" */))
const _35310813 = () => interopDefault(import('../../../pages/backoffice/usermanagement/roles/edit.vue' /* webpackChunkName: "pages/backoffice/usermanagement/roles/edit" */))
const _88be9d28 = () => interopDefault(import('../../../pages/backoffice/usermanagement/users/_uuid.vue' /* webpackChunkName: "pages/backoffice/usermanagement/users/_uuid" */))
const _2c2794df = () => interopDefault(import('../../../pages/password/reset/_token/index.vue' /* webpackChunkName: "pages/password/reset/_token/index" */))
const _2b0675fe = () => interopDefault(import('../../../pages/registration/confirm-email/_token/index.vue' /* webpackChunkName: "pages/registration/confirm-email/_token/index" */))
const _750e5ba4 = () => interopDefault(import('../../../pages/data-pools/_id/index.vue' /* webpackChunkName: "pages/data-pools/_id/index" */))
const _d115186e = () => interopDefault(import('../../../pages/data-pools/_id/_rowIndex.vue' /* webpackChunkName: "pages/data-pools/_id/_rowIndex" */))
const _f334fd00 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _55b8f802 = () => interopDefault(import('../../../components/ConfigResolver' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contacts",
    component: _1fd31550,
    name: "contacts"
  }, {
    path: "/data-pools",
    component: _76dc8539,
    name: "data-pools"
  }, {
    path: "/documents",
    component: _7d05a12e,
    name: "documents"
  }, {
    path: "/imprint",
    component: _1be2b3b7,
    name: "imprint"
  }, {
    path: "/logged-in",
    component: _262427fe,
    name: "logged-in"
  }, {
    path: "/login",
    component: _500d2497,
    name: "login"
  }, {
    path: "/privacy",
    component: _68f07894,
    name: "privacy"
  }, {
    path: "/register",
    component: _12d8c0b0,
    name: "register"
  }, {
    path: "/tos",
    component: _3a593486,
    name: "tos"
  }, {
    path: "/backoffice/usermanagement",
    component: _9ab3c4aa,
    name: "backoffice-usermanagement"
  }, {
    path: "/data-pools/manage",
    component: _6111e6e4,
    name: "data-pools-manage"
  }, {
    path: "/password/forgot",
    component: _38b3c2f0,
    name: "password-forgot"
  }, {
    path: "/registration/submit",
    component: _69ded25c,
    name: "registration-submit"
  }, {
    path: "/settings/ci",
    component: _2a6c1a00,
    name: "settings-ci"
  }, {
    path: "/settings/legal",
    component: _18bf88e2,
    name: "settings-legal"
  }, {
    path: "/user/profile",
    component: _30be68b2,
    name: "user-profile"
  }, {
    path: "/backoffice/usermanagement/companies",
    component: _cce4bc98,
    name: "backoffice-usermanagement-companies"
  }, {
    path: "/backoffice/usermanagement/registrations",
    component: _0c51e29a,
    name: "backoffice-usermanagement-registrations"
  }, {
    path: "/backoffice/usermanagement/roles",
    component: _9ab097ce,
    name: "backoffice-usermanagement-roles"
  }, {
    path: "/backoffice/usermanagement/users",
    component: _262151a4,
    name: "backoffice-usermanagement-users"
  }, {
    path: "/password/forgot/success",
    component: _35e0a5b9,
    name: "password-forgot-success"
  }, {
    path: "/backoffice/usermanagement/roles/edit",
    component: _35310813,
    name: "backoffice-usermanagement-roles-edit"
  }, {
    path: "/backoffice/usermanagement/users/:uuid",
    component: _88be9d28,
    name: "backoffice-usermanagement-users-uuid"
  }, {
    path: "/password/reset/:token",
    component: _2c2794df,
    name: "password-reset-token"
  }, {
    path: "/registration/confirm-email/:token",
    component: _2b0675fe,
    name: "registration-confirm-email-token"
  }, {
    path: "/data-pools/:id",
    component: _750e5ba4,
    name: "data-pools-id"
  }, {
    path: "/data-pools/:id?/:rowIndex",
    component: _d115186e,
    name: "data-pools-id-rowIndex"
  }, {
    path: "/",
    component: _f334fd00,
    name: "index"
  }, {
    path: "*",
    component: _55b8f802,
    name: "ConfigResolver"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
